import { render, staticRenderFns } from "./ViewLineageTree.vue?vue&type=template&id=2d6880f3&scoped=true"
import script from "./ViewLineageTree.vue?vue&type=script&lang=js"
export * from "./ViewLineageTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6880f3",
  null
  
)

export default component.exports